import { APIS, putApi } from "../utils/api-utils";

export const updateFeature = async (tenantId: string, featureName: string, enabled: boolean) => {
    try {
        const response = await putApi(
            APIS.TENANT_API,
            `/tenant/${tenantId}/features`,
            {
                featureName,
                enabled
            }
        );
        return response;
    } catch (e) {
        console.error(e);
        throw e;
    }
};